import SelectReusableControl from "common/components/Select/SelectReusable";
import Logo from "components/Logo";
import React, { FC, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useReports } from "hooks/useReports";
import { LocalStorageKey, useGetUserData } from "common/helpers/userData";
import { useLocationForReportType } from "hooks/useLocationForReportType";
import { UserRole } from "components/Reports/reportAssets/assets";
import { useTranslation } from "react-i18next";
import { tUserRole } from "i18n/enums";
import { useLogoutMutation } from "features/api/auth/authApiSlice";
import HeaderForReportsTabs from "./assets/headerForReportsTabs";
import LanguageSwitcher from "./LanguageSwitcher";
import "./header.scss";

const Header: FC = () => {
  const { t } = useTranslation();
  const userName = useGetUserData(LocalStorageKey.UserName);
  const userId = useGetUserData(LocalStorageKey.UserId);
  const userRoles = useGetUserData(LocalStorageKey.Roles);
  const selectedRoleValue = useGetUserData(LocalStorageKey.SelectedRole)?.value;

  const location = useLocation();
  const locationString = useLocationForReportType();
  const isFollowUp = locationString === "followup";
  const isInProgress = locationString === "inprogress";
  const isMessagesScreen = locationString === "followup-messages";
  const isControlCenterPath = locationString === "control-center";
  const { setSearchKeyword } = useReports();

  const [prevLocation, setPrevLocation] = useState(location.pathname);
  const [logout] = useLogoutMutation();

  useEffect(() => {
    // Reset searchKeyword when location.pathname changes
    if (prevLocation !== location.pathname) {
      setSearchKeyword("");
      setPrevLocation(location.pathname);
    }
  }, [location, prevLocation, setSearchKeyword]);

  const handleLogout = async () => {
    try {
      await logout().unwrap();
      localStorage.clear();
      window.location.href = "/login";
    } catch (error) {
      console.error("Error during logout", error);
    }
  };

  return (
    <header role="navigation" className="navBarContainer" id="header">
      <div className="navBarInnerContainer">
        <Logo />

        {(isFollowUp ||
          isInProgress ||
          isMessagesScreen ||
          isControlCenterPath) && <HeaderForReportsTabs />}
        <LanguageSwitcher />
        {userId && (
          <div className="userNavAction">
            <div className="workerDtBox">
              {selectedRoleValue !== UserRole.SENIOR_WATCH && userName && (
                <div className="workerName">{userName}</div>
              )}

              {userRoles && (
                <SelectReusableControl
                  optionVal={userRoles.map(
                    (role: { value: number; label: string }) => ({
                      ...role,
                      label: tUserRole(role.value),
                    })
                  )}
                  onChange={(value) => {}}
                />
              )}
            </div>
            <button type="button" className="logoutBtn" onClick={handleLogout}>
              {t("logout")}
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
